import { useProjects } from "@/context/ProjectContext";

export default function ProjectChip() {
  const { active } = useProjects();
  if (!active) return null;
  return (
    <div
      data-testid="project-chip"
      className="px-8 py-2 border-b theme-border bg-black/[0.02] dark:bg-white/[0.02] flex flex-wrap items-center gap-x-5 gap-y-1 text-[11px] font-mono-data theme-ink-muted uppercase tracking-widest"
    >
      <span className="theme-ink">{active.name}</span>
      <span>{active.sector}{active.sub_sector ? ` · ${active.sub_sector}` : ""}</span>
      <span>{active.country_code}</span>
      <span>{Number(active.floor_area_m2 || 0).toLocaleString()} m²</span>
      <span>Target {active.target_intensity_kg_per_m2} kg/m²</span>
    </div>
  );
}
